var zh = {
    "languageArr": ["中", "EN", "JPN"],
    "login": "登录",
    "search": {
        "title": "搜索",
        "cateArr": ["全部", "应用市场", "产品中心", "新闻中心"],
        "placeholder": "请输入关键词搜索",
        "record": "历史记录"
    },
    "product_search": {
        "placeholder": "请输入产品名称, 产品类别, 用途等。",
        "btn": "搜索"
    },
    "statistics_arr": ["技术专长", "专利数量", "研发面积", "研发人员", "科研院校"],
    "unit_arr": ["项", "项", "㎡", "+", "所"],
    "market_language": {
        "title": "应用市场",
        "desc": "专注于高端无机非金属粉体材料应用及解决方案",
        "market": ["电子信息材料", "新能源材料", "半导体材料", "其他行业"],
        "btn": "了解更多"
    },
    "product_language": {
        "title": "产品中心",
        "desc": "以客户为中心, 坚持创新驱动",
        "product": [
            { "name": "硅系", "desc": "硅微粉、球硅、球硅浆料" }, 
            { "name": "铝系", "desc": "角铝、球铝" }, 
            { "name": "氮系", "desc": "氮化铝、氮化硼" },
            { "name": "钛系", "desc": "单晶氧化钛" },
            { "name": "陶瓷系列", "desc": "钛酸钡、透锂长石" },
            { "name": "电子浆料", "desc": "烧结铜浆、固化铜浆" }
        ]
    },
    "group_introduction": {
        "title": "公司介绍",
        "inroduction": {
            "para1": "苏州锦艺新材料科技股份有限公司成立于2017年，系国家级专精特新“小巨人”企业。公司专注于先进无机非金属粉体材料领域，业务前身可追溯至2005年创立的重庆锦艺，历经二十余载耕耘，构建起集粉体合成、超细加工、球形制备、表面改性多位一体的技术平台，全面覆盖电子信息、导热散热、先进涂料、锂电新能源等战略新兴领域，并在覆铜板用无机功能粉体领域取得领先地位，连续多年销售规模位列行业第一。公司核心产品电子级高纯超细球型硅微粉广泛应用于当前最高技术等级的覆铜板，如Megtron8级高速覆铜板、IC载板以及类载板（SLP），适配AI服务器等高阶应用场景。 ",
            "para2": "作为业内领先的高端粉体材料供应商，锦艺新材具备全球化的优质客户矩阵。电子信息领域，公司已与全球前二十大刚性覆铜板厂商如台光电子、台燿科技、建滔电子、联茂电子、南亚电子、日本松下电工、生益科技、南亚新材等建立长期稳定合作；导热散热领域，公司已与国际知名导热界面材料企业汉高、莱尔德等建立稳定合作关系；此外，公司产品已进驻锂电池隔膜、高端涂料龙头企业供应链体系，牵手恩捷股份、阿克苏诺贝尔等世界知名企业。",
            "para3": "公司总部坐落于江苏省苏州市，地处长三角核心枢纽，坐拥万亿级产业集群，汇集顶尖产学研资源，公司吸纳各领域专业技术人才，专注于自主研发和底层创新，致力于成为先进无机非金属材料行业引领者，让基础研究成为一种时尚，让关键材料自主可控成为我们的使命。"
        },
    },
    "core_advantage": {
        "title": "核心优势",
        "desc": "创造客户价值, 实现资本增值",
        "core_arr": [
            { "name": "多样技术专长", "desc": "复合配方、超细研磨<br />精密分级、精细球化<br />表面处理、定制浆料<br />" },
            { "name": "多种无机材料", "desc": "立足无机、携手有机<br />融合创新、更新迭代<br />" },
            { "name": "精益生产平台", "desc": "柔性生产、快速交付<br />品质提升、注重环保<br />" },
            { "name": "严格品质管控", "desc": "完善质量体系<br />先进检测仪器<br />优良生产设备<br />权威检测方法<br />" },
            { "name": "定制解决方案", "desc": "客户需求、共同研发<br />共同实验、行业优势<br />" },
            { "name": "开放合作平台", "desc": "外资企业，国有企业<br />科研院校，创业团队<br />" }
        ]
    },
    "our_growth": {
        "title": "我们的成长"
    },
    "company_culture": {
        "title": "企业文化",
        "culture": [
            { "title": "愿景", "desc": "高端无机非金属材料应用及解决方案供应商" },
            { "title": "使命", "desc": "聚焦客户关注的压力和挑战，挖掘无机非金属材料的潜能" },
            { "title": "价值观", "desc": "以客户为中心，坚持创新驱动；以奋斗者为本，践行工匠精神" }
        ]
    },
    "talent_concept": {
        "title": "人才观",
        "concept": [
            { "title": "专业", "desc": "持续学习，知行合一<br />坚持人尽其才，践行工匠精神" },
            { "title": "卓越", "desc": "锐意进取，精益求精<br />追求极致表现，成就非凡价值" },
            { "title": "创新", "desc": "开放包容，拥抱变化<br />坚定持续改善，勇于革故鼎新" }
        ]
    },
    "school": {
        "title": "校企合作"
    },
    "development": {
        "title": "职业发展",
        "desc1": "公司提供管理、专业双通道职业发展路径。",
        "desc2": "其中专业通道包括营销、技术、职能、操作4个序列"
    },
    "salary": {
        "title": "薪酬福利",
        "salary_arr": [
            { "title": "基础薪资", "desc": "基础薪资、绩效、全勤奖、津贴、补贴" },
            { "title": "社会保险", "desc": "公司为所有员工购买五险一金" },
            { "title": "生活服务", "desc": "提供住宿、班车、自助餐厅、运动健身场地" },
            { "title": "激励机制", "desc": "年终奖、项目突破奖、股权、期权激励等" },
            { "title": "员工发展", "desc": "多样化的培训课程和职业发展规划" }
        ],
        "btn": "校园招聘"
    },
    "subsidiary": {
        "btn": "了解详情"
    },
    "honor": {
        "title": "荣誉资质"
    },
    "wechat_code": "官方微信号",
    "contact": {
        "contact_us": "联系我们",
        "phone": "电话",
        "mail": "邮箱",
        "address": "地址",
        "address_detail": "江苏省常熟市经济技术开发区兴港路25-1",
        "copyright": "Copyright©️ 2024 苏州锦艺新材料科技股份有限公司",
        "download": "资料下载",
        "summary": "概要",
        "feature": "特点",
        "function": "用途"
    },
    "fill_information": {
        "title": "申请资料信息填写",
        "desc": "填写资料后，自动下载相关产品文件",
        "not_null": "必填",
        "name": "姓名",
        "unit": "单位名称",
        "department": "部门",
        "mail": "E-mail",
        "confirm": "确认",
        "phone": "电话",
        "query": "查询产品",
        "select": "请选择",
        "content": "具体内容",
        "submit": "确认"
    },
    "read_more": {
        "btn": "了解更多"
    }
}

export default zh